import WordInsideWriteMultyArea from "@/pages/comp/plan/word/word_inside/common/write_multy";

function WordInsideWriteMultyPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    info_arr: [],
    ...props
  };

  return (
    <div>
      <WordInsideWriteMultyArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        info_arr={myProps.info_arr}
      ></WordInsideWriteMultyArea>
    </div>
  );
};
export default WordInsideWriteMultyPopup;